// extracted by mini-css-extract-plugin
export var boxItems = "_94-1";
export var boxItemsLg = "_94-2";
export var button = "_94-7";
export var buttonHoverless = "_94-9";
export var buttonLg = "_94-8";
export var filterGroupBox = "_94-0";
export var icon = "_94-3";
export var iconSecondary = "_94-6";
export var iconWrapper = "_94-4";
export var iconWrapperLg = "_94-5";
export var truncatedLabel = "_94-a";